import { Input } from "antd";
import { Eye, EyeOff } from "lucide-react";

function AppInput({
  id,
  onBlur,
  onChange,
  value,
  label,
  placeholder,
  name,
  prefix,
  suffix,
  className = "",
  containerClassName = "",
  required = false,
  labelClassName = "",
  requiredClassName = "",
  labelExtra = "",
  error,
  restrictLeadingSpace = true,
  restrictConsecutiveSpaces = true,
  ...props
}) {
  const inputId = id || name;

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      const current = e.target.value || "";
      const cursor = e.target.selectionStart ?? current.length;
      if (restrictLeadingSpace && cursor === 0) {
        e.preventDefault();
        return;
      }
      if (
        restrictConsecutiveSpaces &&
        cursor > 0 &&
        current.charAt(cursor - 1) === " "
      ) {
        e.preventDefault();
        return;
      }
    }
    if (props.onKeyDown) props.onKeyDown(e);
  };

  const handleChange = (e) => {
    if (!onChange) return;
    const original = e?.target?.value ?? "";
    let sanitized = original;
    if (restrictLeadingSpace) sanitized = sanitized.replace(/^\s+/, "");
    if (restrictConsecutiveSpaces) sanitized = sanitized.replace(/\s{2,}/g, " ");

    if (e && e.target) {
      const syntheticEvent = {
        ...e,
        target: { ...e.target, name: name || e.target.name, value: sanitized },
      };
      onChange(syntheticEvent);
    } else {
      onChange(sanitized);
    }
  };

  return (
    <div className={`common-input-box ${containerClassName}`}>
      {label && (
        <label htmlFor={inputId} className={`app-label ${labelClassName}`}>
          <div>
            {label}{" "}
            {required && (
              <span className={`required ${requiredClassName}`}>*</span>
            )}
          </div>
          {labelExtra && (
            <span style={{ color: "#64748b", fontSize: 12, marginLeft: 6 }}>
              {labelExtra}
            </span>
          )}
        </label>
      )}
      {props.type === "password" ? (
        <Input.Password
          id={inputId}
          aria-label={label}
          placeholder={placeholder}
          value={value}
          name={name}
          prefix={prefix}
          onBlur={onBlur}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className={`common-input ${className}`}
          required={required}
          iconRender={(visible) =>
            visible ? (
              <Eye className="h-4 w-4 text-mahogany" strokeWidth={1.5} />
            ) : (
              <EyeOff className="h-4 w-4 text-mahogany" strokeWidth={1.5} />
            )
          }
          {...props}
          type={undefined}
        />
      ) : (
        <Input
          id={inputId}
          aria-label={label}
          placeholder={placeholder}
          value={value}
          name={name}
          prefix={prefix}
          suffix={suffix}
          onBlur={onBlur}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className={`common-input ${className}`}
          required={required}
          {...props}
        />
      )}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default AppInput;
